<template>
	<PopupRouterViewDetail label="Approval History Detail" @copyDataMethod="copyDataAction">
<!-- APP_DETAIL_HEADER -->
		<b-card>
			<b-col cols="12" lg="6">
					<b-form-group id="fieldset-approval-instance" label-cols-sm="4" label-cols-lg="3" label="Approval Instance" label-for="filter-approval-instance">
						{{ model != null ? ( model.approvalInstance != null ? model.approvalInstance.approvalTag : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-approver-type" label-cols-sm="4" label-cols-lg="3" label="Approver Type" label-for="filter-approver-type">
						{{ model != null ? ( model.approverType != null ? model.approverType.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-approval-structure" label-cols-sm="4" label-cols-lg="3" label="Approval Structure" label-for="filter-approval-structure">
						{{ model != null ? ( model.approvalStructure != null ? model.approvalStructure.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-approver-level" label-cols-sm="4" label-cols-lg="3" label="Approver Level" label-for="filter-approver-level">
						{{ model != null ? model.approverLevel : "" }}
					</b-form-group>
					<b-form-group id="fieldset-approver-user-name" label-cols-sm="4" label-cols-lg="3" label="Approver User Name" label-for="filter-approver-user-name">
						{{ model != null ? model.approverUserName : "" }}
					</b-form-group>
					<b-form-group id="fieldset-sequence" label-cols-sm="4" label-cols-lg="3" label="Sequenc" label-for="filter-sequence">
						{{ model != null ? model.sequence : "" }}
					</b-form-group>
					<b-form-group id="fieldset-acitivty-state" label-cols-sm="4" label-cols-lg="3" label="Activity State" label-for="filter-acitivty-state">
						{{ model != null ? ( model.acitivtyState != null ? model.acitivtyState.name : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-approval-configuration-instance-detail" label-cols-sm="4" label-cols-lg="3" label="Approval Configuration Instance Detail" label-for="filter-approval-configuration-instance-detail">
						{{ model != null ? ( model.approvalConfigurationInstanceDetail != null ? model.approvalConfigurationInstanceDetail.approverType : "") : "" }}
					</b-form-group>
					<b-form-group id="fieldset-message" label-cols-sm="4" label-cols-lg="3" label="Message" label-for="filter-message">
						{{ model != null ? model.message : "" }}
					</b-form-group>
					<b-form-group id="fieldset-status" label-cols-sm="4" label-cols-lg="3" label="Status" label-for="filter-status">
						{{ model != null ? model.status : "" }}
					</b-form-group>
			</b-col>
		</b-card>
<!-- END_APP_DETAIL_HEADER -->
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterViewDetail>
</template>
<script>
/*APP_DETAIL_IMPORT*/
import ApprovalHistory from '@/models/ApprovalHistory/ApprovalHistory';
import ApprovalHistoryList from '@/models/ApprovalHistory/ApprovalHistoryList';
import ApprovalHistoryFilter from '@/filters/ApprovalHistory/ApprovalHistoryFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
/*END_APP_DETAIL_IMPORT*/
export default {
	components : {
	/*APP_DETAIL_PROP_DEFINITION*/
	PopupRouterViewDetail,AppInputDatetimepicker,AppInputDatetimepickerRange,
	/*APP_DETAIL_COMPONENTS_DEFINITION*/
},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			model: {},
			/*APP_DETAIL_PAGINATION*/
			/*END_APP_DETAIL_PAGINATION*/
			/*APP_DETAIL_FILTER*/
			filterApprovalHistory : null,
			/*END_APP_DETAIL_FILTER*/
			/*APP_DETAIL_PAGING_DEFINITION*/
			currentApprovalHistoryPage : 1,
			approvalHistoryPageSize: 10,
			/*END_APP_DETAIL_PAGING_DEFINITION*/
			/*APP_DETAIL_SORT_DEFINITION*/
			sortByApprovalHistory: '',
			sortDescApprovalHistory: '',
			/*END_APP_DETAIL_SORT_DEFINITION*/
			/*APP_DETAIL_VARIABLE_DEFINITION*/
			/*END_APP_DETAIL_VARIABLE_DEFINITION*/
			/*APP_DETAIL_OBJ_VARIABLE*/
			/*END_APP_DETAIL_OBJ_VARIABLE*/
		}
	},
	methods : {
		/*APP_DETAIL_GETApprovalHistory*/
		getApprovalHistory : async function(id) {
			this.isBusy = true;
			ApprovalHistory.getData(this, id).then(result => { this.model = result; this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		/*END_APP_DETAIL_GETApprovalHistory*/
		/*APP_DETAIL_COPYDATA*/
		copyDataAction(modelEvent) {
			this.$router.push({ name: 'approvalhistorycopydata', params: { id: this.modelId, copydata : 1 } })
		},
		/*END_APP_DETAIL_COPYDATA*/
		/*APP_DETAIL_DISPLAYFILTER*/
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		/*END_APP_DETAIL_DISPLAYFILTER*/
	},
	/*APP_DETAIL_BEFORE_MOUNT*/
	beforeMount() {
		this.filterApprovalHistory = new ApprovalHistoryFilter();
	},
	/*END_APP_DETAIL_BEFORE_MOUNT*/
	/*APP_DETAIL_MOUNTED*/
	mounted(){
		let id = this.$route.params.id;
		this.modelId = id;
		this.getApprovalHistory(id);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	/*END_APP_DETAIL_MOUNTED*/
	watch : {
	},
	/*APP_DETAIL_COMPUTED*/
	computed: {
	}
	/*END_APP_DETAIL_COMPUTED*/
}
</script>
